export const globalInitialState = {
  globalSearchData: {},
};
const GlobalSearchReducer = (state: any, action: any) => {
  const { type, payload } = action;

  switch (type) {
    case "SAVE_GLOBALSEARCHDATA":
      return {
        ...state,
        globalSearchData: { ...state.globalSearchData, ...payload },
      };
    case "REMOVE_GLOBALSEARCHDATA":
      return {
        ...state,
        globalSearchData: { ...state.globalSearchData, ...payload },
      };
    case "CLEAR_GLOBALSEARCHDATA":
      return {
        ...state,
        globalSearchData: null, // Resetting globalSearchData to null
      };
    default:
      throw new Error(`No case for type ${type} found in GlobalSearchReducer.`);
  }
};

export default GlobalSearchReducer;
